import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ad58065"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detailBox" }
const _hoisted_2 = { class: "borderBottom mb10" }
const _hoisted_3 = { class: "flexBox" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "申请原因：", -1))
const _hoisted_6 = { class: "item-value text-overflow2" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "是否入驻产业园：", -1))
const _hoisted_9 = { class: "item-value text-overflow2" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原办公地址：", -1))
const _hoisted_12 = { class: "item-value text-overflow2" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新办公地址：", -1))
const _hoisted_15 = { class: "item-value text-overflow2" }
const _hoisted_16 = { class: "detail-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "工商注册地址：", -1))
const _hoisted_18 = { class: "item-value text-overflow2" }
const _hoisted_19 = { class: "flexBox borderBottom" }
const _hoisted_20 = { class: "detail-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原办公面积：", -1))
const _hoisted_22 = { class: "item-value" }
const _hoisted_23 = { class: "detail-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新办公面积：", -1))
const _hoisted_25 = { class: "item-value" }
const _hoisted_26 = { class: "detail-item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原区域：", -1))
const _hoisted_28 = { class: "item-value" }
const _hoisted_29 = { class: "detail-item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "现区域：", -1))
const _hoisted_31 = { class: "item-value" }
const _hoisted_32 = { class: "detail-item" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原租金(含物业费)：", -1))
const _hoisted_34 = { class: "item-value" }
const _hoisted_35 = { class: "detail-item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新租金(含物业费)：", -1))
const _hoisted_37 = { class: "item-value" }
const _hoisted_38 = { class: "detail-item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原租赁起止时间：", -1))
const _hoisted_40 = { class: "item-value" }
const _hoisted_41 = { class: "detail-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新租赁起止时间：", -1))
const _hoisted_43 = { class: "item-value" }
const _hoisted_44 = { class: "detail-item" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原址职场押金：", -1))
const _hoisted_46 = { class: "item-value" }
const _hoisted_47 = { class: "detail-item" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新址职场押金：", -1))
const _hoisted_49 = { class: "item-value" }
const _hoisted_50 = { class: "detail-item" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "原址可容纳人数：", -1))
const _hoisted_52 = { class: "item-value" }
const _hoisted_53 = { class: "detail-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新址可容纳人数：", -1))
const _hoisted_55 = { class: "item-value" }
const _hoisted_56 = { class: "detail-item" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "出租房名称：", -1))
const _hoisted_58 = { class: "item-value" }
const _hoisted_59 = { class: "detail-item" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "本次租赁期限：", -1))
const _hoisted_61 = { class: "item-value" }
const _hoisted_62 = { class: "detail-item" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "首期需支付现金流：", -1))
const _hoisted_64 = { class: "item-value" }
const _hoisted_65 = { class: "detail-item" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "出租房是否为大产权单位：", -1))
const _hoisted_67 = { class: "item-value" }
const _hoisted_68 = { class: "detail-item" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "出租房是否提供正规发票：", -1))
const _hoisted_70 = { class: "item-value" }
const _hoisted_71 = { class: "detail-item borderBottom column" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "新址预计装修费用（如有需与预算表一致）：", -1))
const _hoisted_73 = { class: "item-value wrap-box" }
const _hoisted_74 = { class: "detail-item borderBottom column" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "换租理由（原则上分公司每年最多换租一次，一般两年一次）：", -1))
const _hoisted_76 = { class: "item-value wrap-box" }
const _hoisted_77 = {
  key: 0,
  class: "detail-item column borderBottom mb1"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "房屋照片", -1))
const _hoisted_79 = { class: "flexBox" }
const _hoisted_80 = { class: "detail-item borderBottom column" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item-label" }, "换租的损失：", -1))
const _hoisted_82 = { class: "item-value wrap-box" }

import { reactive,withDefaults,watch} from "vue";
// import photoWallUpload from "@/components/photoWallUpload.vue"
import Image from "@/components/Image.vue"
import {
  addressDetailApi,//地址详情
 } from "@/api/businessChange";
import change from "@/composables/change"

export default /*#__PURE__*/_defineComponent({
  props: {
    BranchCompanyFlowId: { default: 0 },
    update: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { BranchCompanyFlowId: number, update: boolean }



// 表单字段定义
const FormData = reactive({
  PageFiles:[],
  PageData:{
    ReasonType:undefined,
    ReasonTypeText:undefined,
    IsEnter:undefined,
    IsEnterDesc:undefined,
    AddressBefore:undefined,
    AddressAfter:undefined,
    BusinessRegisteredAddress:undefined,
    OfficeSpaceOld:undefined,
    OfficeSpaceNew:undefined,
    ProvinceCodeOld:"",
    ProvinceNameOld:'',
    RentSalaryOld:'',
    RentSalaryNew:'',
    RentStartTimeOld:'',
    RentEndTimeOld:'',
    RentStartTimeNew:'',
    RentEndTimeNew:'',
    WorkplaceSalaryOld:'',
    WorkplaceSalaryNew:'',
    CapacityOld:'',
    CapacityNew:'',
    RentHouseName:'',
    RentDeadline:'',
    PayTypeDesc:'',
    FirstPayment:'',
    IsBigPropertyOrg:undefined,
    IsProvideInvoice:undefined,
    DecorationCostDesc:'',
    ChangeRentReason:'',
    RentTimeNew:[],
    RentTimeOld:[],
    TraceId:'',
    cityOldName:'',
    cityNewName:'',
  }
});

//封装方法字段
const common = reactive({
  DetailApi:addressDetailApi,
  FormData:FormData,
  nodeIdx:1,
  props:reactive(props),
})

const {
  getDetail,
} = change(common)

watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getDetail(props.BranchCompanyFlowId)
    }
  },{ deep: true },
);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(FormData).PageData.ReasonTypeText), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(FormData).PageData.IsEnterDesc), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(FormData).PageData.AddressBefore), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(FormData).PageData.AddressAfter), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(FormData).PageData.BusinessRegisteredAddress), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(FormData).PageData.OfficeSpaceOld) + "平方米", 1)
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(FormData).PageData.OfficeSpaceNew) + "平方米", 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _hoisted_27,
        _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(FormData).PageData.cityOldName), 1)
      ]),
      _createElementVNode("div", _hoisted_29, [
        _hoisted_30,
        _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(FormData).PageData.cityNewName), 1)
      ]),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(FormData).PageData.RentSalaryOld) + "元/月", 1)
      ]),
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(FormData).PageData.RentSalaryNew) + "元/月", 1)
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(FormData).PageData.RentStartTimeOld) + " - " + _toDisplayString(_unref(FormData).PageData.RentEndTimeOld), 1)
      ]),
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createElementVNode("span", _hoisted_43, _toDisplayString(_unref(FormData).PageData.RentStartTimeNew) + " - " + _toDisplayString(_unref(FormData).PageData.RentEndTimeNew), 1)
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(FormData).PageData.WorkplaceSalaryOld) + "元", 1)
      ]),
      _createElementVNode("div", _hoisted_47, [
        _hoisted_48,
        _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(FormData).PageData.WorkplaceSalaryNew) + "元", 1)
      ]),
      _createElementVNode("div", _hoisted_50, [
        _hoisted_51,
        _createElementVNode("span", _hoisted_52, _toDisplayString(_unref(FormData).PageData.CapacityOld) + " 人", 1)
      ]),
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("span", _hoisted_55, _toDisplayString(_unref(FormData).PageData.CapacityNew) + " 人", 1)
      ]),
      _createElementVNode("div", _hoisted_56, [
        _hoisted_57,
        _createElementVNode("span", _hoisted_58, _toDisplayString(_unref(FormData).PageData.RentHouseName), 1)
      ]),
      _createElementVNode("div", _hoisted_59, [
        _hoisted_60,
        _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(FormData).PageData.RentDeadline), 1)
      ]),
      _createElementVNode("div", _hoisted_62, [
        _hoisted_63,
        _createElementVNode("span", _hoisted_64, _toDisplayString(_unref(FormData).PageData.FirstPayment) + "万元", 1)
      ]),
      _createElementVNode("div", _hoisted_65, [
        _hoisted_66,
        _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(FormData).PageData.IsBigPropertyOrgDesc), 1)
      ]),
      _createElementVNode("div", _hoisted_68, [
        _hoisted_69,
        _createElementVNode("span", _hoisted_70, _toDisplayString(_unref(FormData).PageData.IsProvideInvoiceDesc), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _hoisted_72,
      _createElementVNode("span", _hoisted_73, _toDisplayString(_unref(FormData).PageData.DecorationCostDesc), 1)
    ]),
    _createElementVNode("div", _hoisted_74, [
      _hoisted_75,
      _createElementVNode("span", _hoisted_76, _toDisplayString(_unref(FormData).PageData.ChangeRentReason), 1)
    ]),
    (_unref(FormData).PageFiles.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
          _hoisted_78,
          _createElementVNode("div", _hoisted_79, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FormData).PageFiles, (item) => {
              return (_openBlock(), _createBlock(Image, {
                key: item,
                value: item.FileUrl,
                disable: true,
                "disable-close": true
              }, null, 8, ["value"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_80, [
      _hoisted_81,
      _createElementVNode("span", _hoisted_82, _toDisplayString(_unref(FormData).PageData.ChangeRentLose), 1)
    ])
  ]))
}
}

})